import { useRef, useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

export const usePanTo = (target) => {
    const map = useMap();
    const prevRef = useRef(null);

    useEffect(() => {
        if (!map || !target) return;
        if (prevRef.current?.lat === target.lat && prevRef.current?.lng === target.lng) return;
        prevRef.current = target;
        map.panTo(target);
    }, [map, target]);
};

export const PanTo = ({ target }) => {
    usePanTo(target);
    return null;
};